import { AxiosError } from 'axios';

export class HttpError extends Error {
  private readonly status: number;
  private readonly responseBody: unknown;
  private declare readonly requestBody: unknown;

  constructor(requestBody: unknown, err: AxiosError) {
    const status = err?.response?.status || 500;
    const responseBody = err?.response?.data;

    super(
      JSON.stringify({
        response: {
          status: status,
          body: responseBody,
        },
      })
    );

    this.status = status;
    this.responseBody = responseBody;
    // The body may carry the caller's credentials: kept off the enumerable properties
    // that console.* prints and JSON.stringify serializes, and out of the message.
    Object.defineProperty(this, 'requestBody', {
      value: requestBody,
      enumerable: false,
    });
  }

  public errorMessage() {
    return {
      response: {
        status: this.status,
        body: this.responseBody,
      },
      request: {
        body: this.requestBody,
      },
    };
  }

  get response() {
    return {
      status: this.status,
      body: this.responseBody,
    };
  }

  get request() {
    return {
      body: this.requestBody,
    };
  }
}
